import { NeoState } from '../Reducers.interface';

export const selectSelecteCustomer = (state: NeoState) => state.bookings.selectedCustomers;
